// router/index.js
import { createRouter, createWebHistory } from 'vue-router'



const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home/Home.vue'),
  },
  {
    path: '/About',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About/About.vue'),
  },
  {
    path: '/Station_Introduction',
    name: 'Station_Introduction',
    component: () => import(/* webpackChunkName: "station-introduction" */ '../views/Station/Station_Introduction.vue'),
  },
  {
    path: '/Station_Map',
    name: 'Station_Map',
    component: () => import(/* webpackChunkName: "station-map" */ '../views/Station/Station_Map.vue'),
  },
  {
    path: '/Station_Details',
    name: 'Station_Details',
    component: () => import(/* webpackChunkName: "station-details" */ '../views/Station/Station_Details.vue'),
  },
  {
    path: '/Station_DataQuality',
    name: 'Station_DataQuality',
    component: () => import(/* webpackChunkName: "station-dataquality" */ '../views/Station/Station_DataQuality.vue'),
  },
  {
    path: '/Data_Catalog',
    name: 'Data_Catalog',
    component: () => import(/* webpackChunkName: "data-catalog" */ '../views/Data/Data_Catalog.vue'),
  },
  {
    path: '/Data_Visualization',
    name: 'Data_Visualization',
    component: () => import(/* webpackChunkName: "data-visualization" */ '../views/Data/Data_Visualization.vue'),
  },
  {
    path: '/Data_SignificantEarthquake',
    name: 'Data_SignificantEarthquake',
    component: () => import(/* webpackChunkName: "data-significant-earthquake" */ '../views/Data/Data_SignificantEarthquake.vue'),
  },
  {
    path: '/Data_SignificantEarthquakeWaveForm',
    name: 'Data_SignificantEarthquakeWaveForm',
    component: () => import(/* webpackChunkName: "data-significant-earthquake-waveform" */ '../views/Data/Data_SignificantEarthquakeWaveForm.vue'),
  },
  {
    path: '/Data_SignificantEarthquakeTravelTimePlot',
    name: 'Data_SignificantEarthquakeTravelTimePlot',
    component: () => import(/* webpackChunkName: "data-significant-earthquake-travel-time" */ '../views/Data/Data_SignificantEarthquakeTravelTimePlot.vue'),
  },
  {
    path: '/Data_ManualEQ',
    name: 'Data_ManualEQ',
    component: () => import(/* webpackChunkName: "data-ManualEQ" */ '../views/Data/Data_ManualEQ.vue'),
  },
  {
    path: '/Data_ManualEQWaveForm',
    name: 'Data_ManualEQWaveForm',
    component: () => import(/* webpackChunkName: "data-ManualEQ-waveform" */ '../views/Data/Data_ManualEQWaveForm.vue'),
  },
  {
    path: '/Data_ManualEQTravelTimePlot',
    name: 'Data_ManualEQTravelTimePlot',
    component: () => import(/* webpackChunkName: "data-ManualEQ-travel-time" */ '../views/Data/Data_ManualEQTravelTimePlot.vue'),
  },
  {
    path: '/Data_WaveForm',
    name: 'Data_WaveForm',
    component: () => import(/* webpackChunkName: "data-waveform" */ '../views/Data/Data_WaveForm.vue'),
  },
  {
    path: '/Data_TravelTimePlot',
    name: 'Data_TravelTimePlot',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_TravelTimePlot.vue'),
  },
  {
    path: '/Data_WebDataServices_Catalog',
    name: 'Data_WebDataServices_Catalog',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_WebDataServices_Catalog.vue'),
  },
  {
    path: '/Data_WebDataServices_MultiStation',
    name: 'Data_WebDataServices_MultiStation',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_WebDataServices_MultiStation.vue'),
  },
  {
    path: '/Data_WebDataServices_Continuous',
    name: 'Data_WebDataServices_Continuous',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_WebDataServices_Continuous.vue'),
  },
  {
    path: '/Data_WebDataServices_MultiEvent',
    name: 'Data_WebDataServices_MultiEvent',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_WebDataServices_MultiEvent.vue'),
  },
  {
    path: '/Data_WebDataServices_Instrument',
    name: 'Data_WebDataServices_Instrument',
    component: () => import(/* webpackChunkName: "data-travel-time" */ '../views/Data/Data_WebDataServices_Instrument.vue'),
  },
  {
    path: '/AutoBATS',
    name: 'AutoBATS',
    component: () => import(/* webpackChunkName: "auto-bats" */ '../views/AutoBATS/AutoBATS.vue'),
  },
  {
    path: '/DataProducts',
    name: 'DataProducts',
    component: () => import(/* webpackChunkName: "data-products" */ '../views/DataProducts/DataProducts.vue'),
  },
  {
    path: '/People',
    name: 'People',
    component: () => import(/* webpackChunkName: "people" */ '../views/People/People.vue'),
  },
  {
    path: '/Links',
    name: 'Links',
    component: () => import(/* webpackChunkName: "links" */ '../views/Link/Links.vue'),
  },
  {
    path: '/Help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "help" */ '../views/Help/Help.vue'),
  },
  {
    path: '/Login_Home',
    name: 'Login_Home',
    component: () => import(/* webpackChunkName: "login-home" */ '../views/Login/Login_Home.vue'),
  },
  {
    path: '/Login_PrivacyPolicy',
    name: 'Login_PrivacyPolicy',
    component: () => import(/* webpackChunkName: "login-privacy-policy" */ '../views/Login/Login_PrivacyPolicy.vue'),
  },
  {
    path: '/Login_Register',
    name: 'Login_Register',
    component: () => import(/* webpackChunkName: "login-register" */ '../views/Login/Login_Register.vue'),
  },
  {
    path: '/Login_RegisterDeclined',
    name: 'Login_RegisterDeclined',
    component: () => import(/* webpackChunkName: "login-register-declined" */ '../views/Login/Login_RegisterDeclined.vue'),
  },
  {
    path: '/Login_ForgotPassword',
    name: 'Login_ForgotPassword',
    component: () => import(/* webpackChunkName: "login-forgot-password" */ '../views/Login/Login_ForgotPassword.vue'),
  },
  {
    path: '/Login_PasswordResetSuccess',
    name: 'Login_PasswordResetSuccess',
    component: () => import(/* webpackChunkName: "login-password-reset-success" */ '../views/Login/Login_PasswordResetSuccess.vue'),
  },
  {
    path: '/Login_TokenExpired',
    name: 'Login_TokenExpired',
    component: () => import(/* webpackChunkName: "login-password-reset-success" */ '../views/Login/Login_TokenExpired.vue'),
  },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 50 };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

export default router;
